<mat-form-field class="input-multi-field">
    <mat-label>{{ label() }}</mat-label>
    <mat-chip-grid #chipGrid [formControl]="formControl()">
        @for (item of items(); track item) {
            <mat-chip-row (removed)="removeItem(item)" [disabled]="disabled">
                {{ item }}
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
        }
        <input
            matInput
            [placeholder]="placeholder()"
            [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes()"
            [matChipInputAddOnBlur]="addOnBlur()"
            [disabled]="disabled"
            (matChipInputTokenEnd)="addItem($event)"
            (blur)="handleBlur()"
        />
    </mat-chip-grid>
    <mat-hint>{{ hint() }}</mat-hint>
    <mat-error matErrorMessages></mat-error>
</mat-form-field>
